var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LoadedContent',{style:(_vm.style),attrs:{"loading":_vm.imageLoading,"skeleton-type":"image"}},[_c('img',{staticClass:"ItemBadge",class:_vm.rounded,style:(_vm.style),attrs:{"src":_vm.item.badge,"alt":"badge"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }